import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ebeihilfe-file-svg',
  templateUrl: './file-svg.component.svg',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class FileSvgComponent {}
